import { Checkbox, Collapse, Divider, FormControl, FormControlLabel, FormGroup, FormLabel } from '@material-ui/core';
import React from 'react';

import styles from '../../styles';
import SendValues from '../SendValues';

interface IProps {
  handlePageChange: (name: string) => () => void;
  handleRadioChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleCustomValue: (value: any, number: any) => void;
  handleSendCampaign: () => void;
  handleBankslipPurchase: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checkCustomValue: (event: React.ChangeEvent<HTMLInputElement>) => void;
  state: IPropsState;
  classes?: any;
}

interface IPropsState {
  id: string;
  step: number;
  advanced: boolean;
  platformId: number;
  platformType: string;
  hasCampaign: boolean;
  hasPrice: boolean;
  hasBankslipPurchase: boolean;
  bankslipPurchase: string;
  pixel: string;
  registered: string[];
  isFetching: boolean;
  tracker: any;
  pages: string[];
  paymentMethods: {
    credit_card: number;
    bankslip: number;
    paypal: number;
    pix: number;
  };
  purchaseValue: string;
  sendCampaign: boolean;
  conversionLabel: string;
}

const pagesCheckboxRender = [
  {
    label: 'Página do Checkout',
    key: 'checkout',
  },
  {
    label: 'Página de Obrigado (Cartão)',
    key: 'thank_you_card',
  },
  {
    label: 'Página de Obrigado (Boleto)',
    key: 'thank_you_bankslip',
  },
  {
    label: 'Visualização do Boleto',
    key: 'bankslip_view',
  },
];

function Advanced({ classes, state, handlePageChange, handleSendCampaign, handleRadioChange, handleCustomValue, checkCustomValue }: IProps) {
  return (
    <Collapse in={state.advanced}>
      <div className='m24' />
      <FormControl className={classes.formControl}>
        <FormLabel>Escolha em quais páginas vai ativar seu pixel</FormLabel>
        <div className='m16' />
        <FormGroup>
          {pagesCheckboxRender.map((pageCheckbox) => (
            <FormControlLabel
              key={pageCheckbox.key}
              control={
                <Checkbox
                  checked={Boolean(state.pages.includes(pageCheckbox.key))}
                  onChange={handlePageChange(pageCheckbox.key)}
                  value={pageCheckbox.key}
                />
              }
              label={pageCheckbox.label}
            />
          ))}
        </FormGroup>
      </FormControl>
      <Divider />
      <div className='m24' />
      {state.hasCampaign && (
        <React.Fragment>
          <FormControl className={classes.formControl}>
            <FormLabel>Campanhas</FormLabel>
            <div className='m8' />
            <FormControlLabel
              control={<Checkbox checked={state.sendCampaign} onChange={handleSendCampaign} />}
              label='Sempre informar a campanha de origem'
            />
          </FormControl>
          <Divider />
        </React.Fragment>
      )}
      <div className='m24' />
      {state.hasBankslipPurchase && (
        <React.Fragment>
          <FormControl className={classes.formControl}>
            <FormLabel>Vendas de Boleto</FormLabel>
            <FormControlLabel
              className={classes.group}
              control={<Checkbox checked value={state.bankslipPurchase} disabled />}
              label='Sempre enviar evento Purchase no boleto'
            />
            <div className='m8' />
          </FormControl>
          <p className={classes.customMessage}>
            Não podemos enviar o evento de <b>&quot;Purchase após o boleto ser pago&quot;</b>, pois fere os{' '}
            <a href='https://www.facebook.com/about/privacy' target='_blank' rel='noopener noreferrer'>
              Termos de Privacidade do Facebook
            </a>
            . Para parar de receber o evento, desmarque a opção <b>&quot;Página de Obrigado (Boleto)&quot;</b> em{' '}
            <b>&quot;Escolha em quais páginas vai ativar seu pixel&quot;</b> nesse formulário.
          </p>
          <Divider />
          <div className='m24' />
        </React.Fragment>
      )}
      {state.hasPrice && (
        <React.Fragment>
          <SendValues state={state} handleRadioChange={handleRadioChange} handleCustomValue={handleCustomValue} checkCustomValue={checkCustomValue} />
          <Divider />
        </React.Fragment>
      )}
    </Collapse>
  );
}

export default styles(Advanced);
